import * as React from 'react';
import Drawer from '@mui/material/Drawer';

interface CustomDrawerProps {
  openDrawer: boolean;
  toggleDrawer: (open: boolean, data: any) => void;
  DrawerItem: React.ReactElement;
}

const CustomDrawer: React.FC<CustomDrawerProps> = ({ openDrawer, toggleDrawer, DrawerItem }) => {
  return (
    <React.Fragment key="right">
      <Drawer
        sx={{
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: '70%',
            boxSizing: 'border-box',
          },
        }}
        anchor="right"
        open={openDrawer}
        onClose={() => toggleDrawer(false, null)}
      >
        {DrawerItem}
      </Drawer>
    </React.Fragment>
  );
};

export default CustomDrawer;
